import { Button, Form, DatePicker, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import {
    DedupeConfigPayload,
    saveDedupeConfig,
    getDedupeConfig,
    MstRequest
} from 'api/master';
//import { Modal } from 'antd';
import FundAccountList1 from '../Dedupelist/index';
import moment from 'moment';


const mstRequest: MstRequest = {};

const Filter = () => {
    const isAdmin = sessionStorage.getItem('isAdmin');
    const [form] = Form.useForm<DedupeConfigPayload>();
    //mstRequest.userName = "";
    const [filter, setFilter] = useState(mstRequest);
    const dateFormat = 'DD-MM-YYYY';
    const [currentStartDate, setCurrentStartDate] = useState<string>('');
    const [currentEndDate, setCurrentEndDate] = useState<string>('');



    useEffect(() => {
        getDedupeConfig(mstRequest)
            .then((response) => {
                debugger;
                const dedupeconfig = response.data;
                setCurrentStartDate(moment(dedupeconfig.dedupeStartDate).format(dateFormat));
                setCurrentEndDate(moment(dedupeconfig.dedupeEndDate).format(dateFormat));
            })
            .catch((error) => {
                message.error('Error fetching dedupe config:', error);
            });
    }, []);


    const handleSubmit = useCallback(
        async (values: DedupeConfigPayload) => {
            //Validations
            debugger;
            const currentDate = moment();
            const dedupeStartDate = moment(values.dedupeStartDate, dateFormat);
            const dedupeEndDate = moment(values.dedupeEndDate, dateFormat);


            let isValid: boolean = true;
            if (!values.dedupeStartDate) {
                message.warning('Dedupe Start Date is mandatory.');
                isValid = false;
            }

            if (!values.dedupeEndDate) {
                message.warning('Dedupe End Date is mandatory.');
                isValid = false;
            }

            if (dedupeStartDate.isBefore(currentDate, 'day')) {
                message.warning('Dedupe start date cannot be back-dated.');
                isValid = false;
            }

            if (dedupeStartDate.isSame(dedupeEndDate, 'day')) {
                message.warning('Dedupe start date cannot be the same as dedupe end date.');
                isValid = false;
            }


            if (isValid) {
                debugger;
                values.dedupeStartDate = dedupeStartDate.format(dateFormat);
                values.dedupeEndDate = dedupeEndDate.format(dateFormat);
                values.configBy = sessionStorage.getItem('user')?.toString();
                values.trailId = 0;
                values.configDate = "";

                saveDedupeConfig(values)
                    .then((res) => {
                        if (res.message == 'Configuration Saved Successfully!') {
                            message.success('Dedupe Date saved successfully');
                        } else {
                            message.error(res.message);
                        }
                        //window.location.reload();
                    })
                    .finally(() => {
                        setFilter(mstRequest);
                        window.location.reload();
                    });
            }
        },
        [form]
    );

    function handleReset(_e: any) {
        form.resetFields();
        let updatedFilter = { ...filter };
        updatedFilter = mstRequest;
        setFilter(updatedFilter);
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <div className="mid-container">
                        <div className="submission-box">
                            <h2>Dedupe Configuration Master</h2>
                            <div className="submission-htmlForm">
                                <Form<DedupeConfigPayload>
                                    form={form}
                                    onFinish={handleSubmit}
                                    layout="vertical"
                                    scrollToFirstError
                                    className="standard-forms"
                                    initialValues={{
                                        ['Username']: sessionStorage.getItem('user')?.toString(),
                                        ['SourceApplicationName']:
                                            isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <label htmlFor="txtCurrentDedupeStartDate" className="fieldTitle">
                                                Current Dedupe Start Date :
                                            </label>
                                            <span id="txtCurrentDedupeStartDate" className="form-control prime-date">{currentStartDate}</span>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <label htmlFor="txtCurrentDedupeEndDate" className="fieldTitle">
                                                Current Dedupe End Date :
                                            </label>
                                            <span id="txtCurrentDedupeEndDate" className="form-control prime-date">{currentEndDate}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-4">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'New Dedupe Start Date :'}
                                                    name="dedupeStartDate"
                                                    className="fieldTitle"
                                                >
                                                    <DatePicker format={dateFormat} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-4">
                                            <div className="input-box">
                                                <Form.Item label={'New Dedupe End Date :'} name="dedupeEndDate" className="fieldTitle">
                                                    <DatePicker format={dateFormat} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="payment-button">
                                            <Button
                                                className="proceed-btn"
                                                id="btnSubmit"
                                                htmlType="submit"
                                                size="small"
                                                style={{ height: '40px', width: '100px' }}
                                            >
                                                APPLY
                                            </Button>
                                            &nbsp;&nbsp;
                                            <Button
                                                className="proceed-btn"
                                                onClick={handleReset}
                                                size="small"
                                                style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                                            >
                                                CLEAR
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            <FundAccountList1 filter={{ ...filter }} onSubmit={handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Filter;
